import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

import "./assets/scss/App.scss";
import "./tailwind.css"; // TailwindCSS loaded after Bootstrap to ensure proper precedence
import Environment from "./common/components/Environment";
import Routes from "./routes";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      //5 min
      staleTime: 300000,
      cacheTime: 600000,
    },
  },
});

function App() {
  return (
    <div id="app" className={"position-relative"}>
      <QueryClientProvider client={queryClient}>
        <Environment />
        <Routes />
        <ReactQueryDevtools initialIsOpen={false} position="top-left" />
      </QueryClientProvider>
    </div>
  );
}

export default App;
